import { render, staticRenderFns } from "./DnevnaParkingKarta.vue?vue&type=template&id=61c0fe06&"
import script from "./DnevnaParkingKarta.vue?vue&type=script&lang=js&"
export * from "./DnevnaParkingKarta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports